import { Button, Upload, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startCargaComprobantePagoPDF } from "../../../../../context/actions/pagos2Actions";

export default function ModalCargarPDFPago({ visible, onClose, ordenPagoID, onSuccess }) {
  const dispatch = useDispatch();
  const { usuarioID } = useSelector((state) => state.userReducer.user);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const props = {
    beforeUpload: (file) => {
      setFile(file);
      return false;
    },
    maxCount: 1,
    showUploadList: false,
  };

  const handleOk = async () => {
    if (!file) {
      return;
    }

    setLoading(true);

    try {
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("filename", "file");
      formdata.append("mimetype", "application/pdf");
      formdata.append("ordenPagoID", ordenPagoID);
      formdata.append("tipo", 1); // 1 = pago
      formdata.append("usuarioID", usuarioID);

      const result = await dispatch(startCargaComprobantePagoPDF(formdata));

      if (result.success) {
        setFile(null);
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFile(null);
    onClose();
  };

  return (
    <Modal
      title="Cargar Comprobante de Pago"
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="Cargar"
      cancelText="Cancelar"
      className="pagos-v2-modal"
      wrapClassName="pagos-v2-modal"
    >
      <div style={{ marginBottom: 20 }}>
        Recuerda que el nombre es OP OrdenPagoID.pdf
      </div>

      <Upload {...props} style={{ width: "100%" }}>
        <Button
          style={{ textAlign: "left" }}
          icon={<UploadOutlined />}
        >
          Seleccione documento
        </Button>
      </Upload>
      {file && <span style={{ marginLeft: 20 }}>{file.name}</span>}
    </Modal>
  );
}
